import CostCenterBaseController from '../common/cost_center.base.controller';

class CostCenterEditController extends CostCenterBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, CostCenterService, Modal, $translate, $stateParams, CommonLayoutService) {
        super(Auth, $state, User, CostCenterService, Modal, $translate, $stateParams)
        this.pageName = `costCenter`;
        this.Auth = Auth;
        this.$state = $state;
        this.User = User;
        this.CommonLayoutService = CommonLayoutService;
        this.message = 'CostCenter Create';
        this.rawId = '';
        this.defaultModel = {
            status: true,
            name: null,
            description: null,
            customerFlag: false
        }
        this.model = angular.copy(this.defaultModel)
        this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: this.$translate.instant('common.yes'),
                off: this.$translate.instant('common.no')
            },
            onColor: 'success',
            offColor: 'danger'
        }
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() {
        this.loading = true;
        this.Service.get(this.$stateParams.id)
            .then((data) => {
                this.defaultModel = data;
                this.rawId = data.id;
                this.model.id = data.id;
                this.model.name = data.name;
                this.model.status = data.status;
                this.model.description = data.description;
                this.model.customerFlag = data.customerFlag;
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.errorMessage += e.message + '<br/>'
                })
            })
            .finally(() => {
                this.loading = false;
            })
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
    }

    submit(evt) {
        this.loading = true;
        this.Service.update(this.rawId, {
            id: this.rawId,
            name: this.model.name,
            status: this.model.status,
            description: this.model.description,
            customerFlag: this.model.customerFlag
        }, this.branchId)
            .then((data) => {
                this.loading = false;
                window.history.go(-1);
            })
            .catch((err) => {
                this.loading = false;
                if (err && err.data && err.data.errors) {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                }
                else {
                    this.errorMessage = err.data.message;
                }
            })
    }

    askToChange() {
        if (!this.model.status) {
            this.model.status = !this.model.status
            this.Modal.confirm({
                header: this.$translate.instant(`${this.pageName}.suspend_${this.pageName}`),
                message: this.$translate.instant(`${this.pageName}.suspend_${this.pageName}_message`),
                callback: ({
                    modal,
                    $scope
                }) => {
                    this.model.status = !this.model.status;
                    modal.close();
                },
                negative: ({
                    modal,
                    $scope
                }) => {
                    modal.close();
                },
                type: 'danger',
                buttons: [this.$translate.instant('common.yes'), this.$translate.instant('common.yes')]
            })
        }
    }

}

export default CostCenterEditController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/edit/cost_center.edit.controller.js